import { Routes, Route, Outlet } from "react-router-dom";
import Home from "./pages/Home";
import Footter from "./components/Footter";
import Games from "./pages/Games";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import Navbar from "./components/Navbar";
import SingUp from "./pages/SignUp.jsx";
import SignIn from "./pages/SignIn";
import EmailVerification from "./pages/EmailVerification";
import ResetPassword from "./pages/ResetPassword";
import MyAccount from "./pages/MyAccount.jsx";
import { ToastContainer } from "react-toastify";
import Privacy from "./pages/Privacy.jsx";
import Terms from "./pages/Terms.jsx";
import Refund from "./pages/Refund.jsx";
import { LoadingProvider } from "./context/LoadingContext";
import LoadingOverlay from "./components/LoadingOverlay";

function MainLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footter />
    </>
  );
}

function SubLayout() {
  return <Outlet />;
}

function App() {
  return (
    <LoadingProvider>
    <LoadingOverlay />
    <div
      style={{
        width: "100%",
        minHeight: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "100%",
          margin: "0 auto",
          backgroundColor: "#01010a",
          minHeight: "100%",
          boxShadow: "0 0 50px rgba(0, 0, 0, 0.8)",
        }}
      >
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/games" element={<Games />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/refund-policy" element={<Refund />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/my-account" element={<MyAccount />} />
          </Route>

          <Route element={<SubLayout />}>
            <Route path="/sign-up" element={<SingUp />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/email-verify" element={<EmailVerification />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </div>
    </div>
    </LoadingProvider>
  );
}

export default App;
